import React from "react";
//#region redux
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { FinancialStatementViewFooterProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useAnnualAccountService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const FinancialStatementViewFooter: React.FC<FinancialStatementViewFooterProps> = (props) => {
  const annualAccountService = useAnnualAccountService();
  const { annualAccountReport, reportType } = props;

  const onDownloadClick = async () => {
    return annualAccountReport && annualAccountService.downloadPdf(annualAccountReport?.financialYearId, reportType);
  };

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Download),
          onClick: onDownloadClick,
          type: StyleEnums.DisplayType.Success,
        },
      ]}
      allowForReadOnlyUsers
    />
  );
};

export default FinancialStatementViewFooter;
